import Model from './ModelPortal'

export default class RfidLookup extends Model {  
  resource()
  {
    return 'rfid-lookup'
  }
}
